import RestClient from '../../../../lib/RestClient';

/**
 * User identity from ID Provider (Keycloak)
 */
export interface UserIdentity {
  id: string;
  username: string;
  enabled: boolean;
  emailVerified: boolean;
  email: string;
  firstName: string;
  lastName: string;
  roles: string[];
  attributes: {
    [key: string]: string[]
  }
}

/**
 * User data as stored in InfoSys Database
 */
export interface PortalUserAccount {
  userId?: string;
  name?: string;
  password?: string;
  userType?: string;
  userRole?: string;
  passwordChanged?: string;
  mail?: string;
  language?: string;
  accounts?: {account: string; roles: string[];}[];
  privileges?: string[];
}

/**
 * Combined representation of identity + portal account as returned by user management API
 */
export interface CombinedUserDto {
  userId: string;
  identity: UserIdentity;
  portalAccount?: PortalUserAccount;
  roles?: String[]
}

/**
 * Page / List of users returned by GET [...]/users API call
 */
export interface UserPage {
  currentPage: number;
  pageSize: number;
  totalPages: number;
  totalCount: number;
  search: string;
  content: CombinedUserDto[];
}

export const AVAILABLE_PRIVILEGES = [
  {key: 'offer-vrm', label: 'Angebot VRM'},
  {key: 'inbox', label: 'Postkorb'},
  {key: '1', label: 'Versteigerungen - Schnitt'},
  {key: '11', label: 'Versteigerungen - Topf'},
  {key: 'logistics-plus', label: 'Logistik+ (Zugriff auf alle Konten)'},
  {key: 'manage_users', label: 'Benutzer verwalten', administrative: true}
];

export function fetchUserList(page: number = 0, search: string = '', statusFilter: string = '') {
  return RestClient.get(`users?page=${encodeURIComponent(page)}&search=${encodeURIComponent(search)}&status=${encodeURIComponent(statusFilter)}`);
}

export function fetchUser(userId: string) {
  return RestClient.get(`users/${userId}`);
}

export function checkEmailAvailable(userId: string) {

}

export function saveUserPortalAccount(userId: string, data: PortalUserAccount) {
  return RestClient.put(`users/${userId}/portalAccount`, data);
}

export function deleteUserPortalAccount(userId: string) {
  return RestClient.delete(`users/${userId}/portalAccount`);
}

export function deleteUserIdentity(userId: string) {
  return RestClient.delete(`users/${userId}/identity`);
}

export function updateUserIdentity(userId: string, data: Partial<UserIdentity>) {
  return RestClient.patch(`users/${userId}/identity`, data);
}
export function createUserIdentity(data: Partial<UserIdentity>) {
  return RestClient.post(`users`, data);
}

export function setUserKeycloakRole(userId: string, role: string, enable: boolean) {
  let data: any = {};
  data[role] = enable;

  return RestClient.post(`users/${userId}/roles`, data);
}